import { render } from "./bedBoard.vue?vue&type=template&id=73e14a35&scoped=true"
import script from "./bedBoard.vue?vue&type=script&lang=js"
export * from "./bedBoard.vue?vue&type=script&lang=js"

import "./bedBoard.vue?vue&type=style&index=0&id=73e14a35&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e14a35"]])

export default __exports__